<template>
  <div class="flex align-start sm-font">
    <transition name="lift">
      <div style="
          bottom: 64px;
          left: 8px;
          min-width: 280px;
          max-width: 720px;
          padding: 0;
          position: fixed;
          max-height: calc(100vh - 192px);
          width: calc(100vw - 64px);
          flex: 1 1 66%;
          z-index: 9999999999;
          overflow: visible;
        "
        class="flex p16"
        v-if="$store.state.show.terminal"
      >
        <terminal />
      </div>
    </transition>
    <transition name="lift">
      <admin
        v-if="$store.state.show.admin"
        class="container"
        style="
          bottom: 64px;
          left: 8px;
          min-width: 280px;
          max-width: 720px;
          padding: 0;
          position: fixed;
          max-height: calc(100vh - 192px);
          width: calc(100vw - 64px);
          flex: 1 1 66%;
          z-index: 9999999999;
          overflow: visible;
        "
        :style="$store.state.show.profile && 'max-width:48%'"
      />
    </transition>
    <transition name="lift">
      <div>
        <profile
          v-if="$store.state.show.profile && $store.state.auth.uid"
          :userid="$store.state.auth.uid || null"
          :footer="true"
          class="container"
          style="
          bottom: 64px;
          right: 8px;
          min-width: 280px;
          max-width: 720px;
          padding: 0;
          position: fixed;
          max-height: calc(100vh - 192px);
          width: calc(100vw - 64px);
          flex: 1 1 66%;
          z-index: 9999999999;
          overflow: visible;
        "
          :style="$store.state.show.admin && 'max-width:48%'"
        />
        <login
          class="br32 p16 r8"
          v-if="$store.state.show.profile && !$store.state.auth.uid"
        />
      </div>
    </transition>
    <transition name="lift">
      <cart
        :key="$store.state.componentKeys.cart"
        v-if="
          $store.state.user &&
          $store.state.user[$store.state.auth.uid] &&
          $store.state.user[$store.state.auth.uid].cart &&
          $store.state.show.cart
        "
        class="container"
        style="
          bottom: 64px;
          right: 8px;
          padding: 0;
          position: fixed;
          max-height: calc(100vh - 58px);
          width: calc(100vw - 64px);
          flex: 1 1 66%;
          min-width: 320px;
          z-index: 9999999999;
          max-width: 540px;
          overflow: visible;
        "
      />
    </transition>
    <transition name="lift">
      <state
        list="true"
        nesting="0"
        v-if="$store.state.show.state"
        :statedata="$store.state"
        parent="state"
        class="container v-scroll"
        style="
          padding: 0;
          bottom: 64px;
          right: 8px;
          position: fixed;
          max-height: calc(100vh - 58px);
          flex: 1 1 66%;
          min-width: 320px;
          z-index: 9999999999;
          max-width: 540px;
        "
      />
    </transition>
    <transition name="lift">
      <state
        tree="true"
        nesting="0"
        v-if="$store.state.show.connectivity && $store.state.connectivity"
        :statedata="$store.state.connectivity"
        class="container v-scroll p8"
        :class="
          ($store.state.connectivity.cardano && 'success-border') ||
          'warn-border'
        "
        style="
          bottom: 64px;
          left: 8px;
          position: fixed;
          max-height: calc(100vh - 58px);
          flex: 1 1 66%;
          min-width: 320px;
          z-index: 9999999999;
          max-width: 540px;
        "
      />
    </transition>
    <a
      class="box-glow p8 r8 flex align-center"
      style="border-radius: 100%; width: 16px; height: 16px"
      @click="$set($store.state.show, 'terminal', !$store.state.show.terminal)"
    >
      <i class="fa fa-terminal fa-lg"></i>
    </a>
    <a
      class="box-glow p8 r8 flex align-center"
      style="border-radius: 100%; width: 16px; height: 16px"
      v-if="$store.state.app.basics.database.includes('localhost')"
      @click="
        $set($store.state, 'debug', !$store.state.debug);
        $set($store.state.show, 'state', !$store.state.show.state);
      "
    >
      <i class="fa fa-bug fa-lg"></i>
    </a>
    <div v-if="$store.state.connectivity">
      <i
        @click="
          $store
            .dispatch('api', {
              verb: 'get',
              address: $store.state.cloudapi + 'connectivity',
            })
            .then((d) => {
              $store.commit('set', {
                keys: ['connectivity', 'cardano'],
                val: d.data || false,
              });
              $store.commit('set', {
                keys: ['show', 'connectivity'],
                val: !$store.state.show.connectivity,
              });
            })
        "
        :class="
          $store.state.connectivity.cardano &&
          $store.state.connectivity.cardano.sync_progress &&
          $store.state.connectivity.cardano.sync_progress.status === 'ready'
            ? 'success-text'
            : 'warn-text'
        "
        class="fa fa-chart-network"
      ></i>
      <!-- recheck for blockfrost and shwifty to return matches -->
    </div>
    <div
      style="border-radius: 100%"
      class="box-glow p8 l4 r8 flex align-center column center"
      v-if="
        $store.state.app.user.includes($store.state.auth.uid) ||
        ($store.state.app.advanced.roles.admin &&
          $store.state.app.advanced.roles.admin.members &&
          $store.state.app.advanced.roles.admin.members.includes(
            $store.state.auth.uid
          ))
      "
    >
      <a
        class="align-center flex "
        href
        @click.prevent="
          $store.state.show.admin
            ? $store.commit('closeAll', { except: ['profile'] })
            : $store.state.app.user.indexOf($store.state.auth.uid > -1)
            ? ($store.commit('closeAll', { except: ['profile'] }),
              $set($store.state.show, 'admin', true))
            : void 0
        "
      >
      <img :src="$store.state.show.admin ? '/img/icons/xmbl-bgblur-dark.gif' : '/img/icons/xmbl-admin.png'" alt :style="$store.state.show.admin ? `height: 40px; width: 40px; border-radius: 100%;`: `height: 40px; width: 40px; border-radius: 100%;`">
      </a>
    </div>
    <!-- <reputation
      style="border-radius: 100%; width: 16px; height: 16px"
      class="box-glow container p8 r8 flex align-center column center"
      v-if="$store.state.auth.uid"
      :key="$store.state.componentKeys.reputation + $route.name"
      :fId="
        $route.name === 'profile' && !$route.params.id
          ? $store.state.auth.uid
          : $route.params.iitemid ||
            $route.params.id ||
            $route.params.type ||
            $route.params.pagetitle ||
            $route.name
      "
      :fType="$route.params.type || $route.params.type || $route.name"
    ></reputation>-->
    <div
      style="border-radius: 100%"
      class="box-glow r8 flex align-center column center glow"
    >
      <a
        v-if="$store.state.auth.uid"
        class="align-center flex"
        href
        @click.prevent="
          $store.state.show.profile
            ? $store.commit('closeAll', { except: ['admin'] })
            : $store.state.app.user.indexOf($store.state.auth.uid > -1)
            ? ($store.commit('closeAll', { except: ['admin'] }),
              $set($store.state.show, 'profile', true))
            : void 0
        "
      >
        <user
          class="box-glow"
          :userid="$store.state.auth.uid"
          nolink="true"
          image-only="true"
          displaysize="40"
        />
      </a>
      <a
        v-else
        @click="$set($store.state.show, 'profile', !$store.state.show.profile)"
        class="xs-font flex align-center text-glow"
      >
        <i class="fa-2x fas fa-power-off success-text" />
      </a>
    </div>
    <a
      style="border-radius: 100%"
      class="box-glow p8 r8 flex align-center"
      v-if="
        $store.state.user &&
        $store.state.user[$store.state.auth.uid] &&
        $store.state.user[$store.state.auth.uid].cart &&
        Object.keys($store.state.user[$store.state.auth.uid].cart).length > 0
      "
      type="button"
      @click="$set($store.state.show, 'cart', !$store.state.show.cart)"
    >
      <i class="fa-2x fa fa-shopping-cart success-text"></i>
    </a>
    <!-- <router-link to="wallet" v-if="$store.state.app.basics.modules && $store.state.app.basics.modules.indexOf('blockchain') > -1" class=flex p8" @click.prevent="$store.state.show.wallet ? $store.commit('closeAll') : $store.state.app.user.indexOf(($store.state.auth.uid) > -1) ? ($store.commit('closeAll'), $set($store.state.show, 'wallet', true)) : void 0">
      <i class="fas fa-wallet"></i>
    </router-link>-->

    <!-- <div class="flex around align-center p8">
      <a href @mouseover="show.reveal = true" @mouseleave="show.reveal = false" @click.prevent="$store.state.auth.uid ? $store.dispatch('auth', {type: 'logout'}) : null; $set($store.state.show, 'auth', !$store.state.show.auth)"><i class="r4" :class="$store.state.auth.uid ? 'fas fa-sign-out-alt' : 'fas fa-sign-in-alt'"></i>{{$store.state.auth.uid ? 'Exit' : 'Enter'}}</a> 
    </div>-->
  </div>
</template>
<script>
export default {
  data() {
    return {
      footerLinks: [
        // ['reputation', 'reputation', 'fa fa-star', 'rgba(72, 165, 201, .4)', 'white', 'fn', () => {
        //   this.$set(this.$store.state.show.reputations, this.$route.path, !this.$store.state.show.reputations[this.$route.path])
        // }],
        // ['secretBox', 'Secret', 'fa fa-user-secret', 'rgba(72, 165, 201, .4)', 'white', 'fn', () => {
        //   this.$set(this.$store.state.show, 'secretBox', !this.$store.state.show.secretBox)
        // }]
      ],
      secretCode: "",
      show: {
        admin: false,
        profile: false,
        reveal: "",
        connectivity: false,
      },
    };
  },
  mounted() {
    this.checkconnectivity();
  },
  methods: {
    checkconnectivity() {
      return this.$store
        .dispatch("api", {
          verb: "get",
          address: this.$store.state.cloudapi + "connectivity",
        })
        .then((d) => {
          d.data
            ? this.$store.commit("set", {
                keys: ["connectivity", "cardano"],
                val: d.data,
              })
            : this.$store.commit("set", { key: "connectivity", value: {} });
        });
    },
    checkSecret(id) {
      this.$store
        .dispatch("query", {
          type: "secret-event",
          collection: "secret-event",
          id: id,
        })
        .then((data) => {
          this.$set(this.$store.state, "secretEvent", data);
          setTimeout(() => {
            this.$set(this.$store.state, "secretEvent", null);
            this.$set(this, "secretCode", "");
          }, 10000);
        });
    },
  },
};
</script>